import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateUpdateSearchSettingEntity } from '../../domain/entities/CreateUpdateSearchSettingEntity'

export class CreateUpdateSearchSettingModel extends CreateUpdateSearchSettingEntity {
  constructor(dataDto: CreateUpdateSearchSettingEntity) {
    super()
    mapEntityProperties<CreateUpdateSearchSettingModel>(this, dataDto)
  }
}
